import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Card } from "../ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Field, OLIVE, errMsg } from "./dpaUtils";
import { DpaDashboard } from "./DpaDashboard";

export const ORG_FIELDS = [
  ["name", "Organisation name", true], ["legal_name", "Client legal entity name"], ["trading_name", "Trading name"],
  ["company_number", "Company registration number"], ["registered_address", "Registered address", false, true],
  ["contact_name", "Contact name"], ["contact_email", "Contact email"], ["contact_phone", "Contact phone"],
  ["dp_contact_email", "Data protection contact email"], ["notes", "Notes", false, true],
];

export const OrgForm = ({ value, onChange }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
    {ORG_FIELDS.map(([k, l, req, multi]) => (
      <div key={k} className={multi ? "md:col-span-2" : ""}>
        <Field label={l} required={req} multiline={multi} value={value[k]} onChange={(v) => onChange({ ...value, [k]: v })} testId={`org-field-${k}`} />
      </div>
    ))}
  </div>
);

export const OrganisationsTab = () => {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "" });
  const create = async () => {
    try {
      const { data } = await api.post("/dpa/organisations", form);
      toast.success("Organisation added", { description: data.name });
      nav(`/compliance/organisations/${data.id}`);
    } catch (e) { toast.error("Could not add organisation", { description: errMsg(e) }); }
  };
  return (
    <div className="space-y-4">
      <Card className="rounded-none p-4 flex items-center justify-between">
        <div className="text-sm text-muted-foreground">Every client organisation has its own independent agreement record. Click an organisation to manage its DPA.</div>
        <Button className="rounded-none text-white" style={OLIVE} onClick={() => setOpen(true)} data-testid="add-organisation-btn"><Plus className="h-4 w-4 mr-1" />Add organisation</Button>
      </Card>
      <DpaDashboard />
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-none max-w-2xl" data-testid="add-organisation-dialog">
          <DialogHeader><DialogTitle>Add client organisation</DialogTitle></DialogHeader>
          <OrgForm value={form} onChange={setForm} />
          <DialogFooter><Button className="rounded-none text-white" style={OLIVE} onClick={create} data-testid="save-organisation-btn">Save organisation</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
